import _objectSpread from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
import Failure from "./Prompt/Failure/failure";
import Successful from "./Prompt/Successful/successful";
import nextStep from "@/components/nextStep/nextStep";
export default {
  data: function data() {
    return {
      flag: 1 //基本户认证后 ， flag：1 正常需要认证，2,3 废弃，4 基本户打款已认证，仅查看信息

    };
  },
  components: {
    Failure: Failure,
    Successful: Successful,
    nextStep: nextStep
  },
  computed: _objectSpread({}, mapState(['enterpriseCert'])),
  watch: {
    enterpriseCert: function enterpriseCert(a, b) {
      if (a) {
        if (a.payFlag == 1) {
          this.flag = 4;
        } else {
          this.flag = 1;
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.enterpriseCert) {
      if (this.enterpriseCert.payFlag == 1) {
        this.flag = 4;
      } else {
        this.flag = 1;
      }
    }
  },
  methods: {
    //打款成功 跳转路由
    handOk: function handOk(btnFrom) {
      var _this = this;

      if (this.enterpriseCert.payFlag == 1) {
        this.$router.push('/internalSystem/certification/anAgreement');
        return;
      }

      if (typeof this.enterpriseCert == null || typeof this.enterpriseCert.enterpriseId == 'undefined') {
        return;
      }

      var data = {
        enterpriseId: this.enterpriseCert.enterpriseId
      }; // 基本户认证，查询状态时，相同接口,但查询认证状态不做跳转

      this.requestAPI.CertBasicBankAcco(data).then(function (res) {
        if (btnFrom == null) {
          var _data = Object.assign(_this.enterpriseCert, {
            bast64Contract: res.data.bast64Contract
          });

          _data['payFlag'] = 1;

          _this.$store.commit('onChangeCert', _data);

          var data2 = _this.userInfo;
          data2['payFlag'] = 1;

          _this.$store.commit('onchangeUserInfo', data2);

          _this.$router.push('/internalSystem/certification/anAgreement');
        } else {
          _this.$alert('基本户认证成功!', '认证结果', {
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });
        }
      });
    },
    // 上一步
    cancel: function cancel() {
      if (this.enterpriseCert.payFlag == 1) {
        this.$router.push('/internalSystem/certification/phoneAuthentication');
      }
    }
  }
};